// extracted by mini-css-extract-plugin
export default {"diskQuota":"DiskQuota_diskQuota__b0fcj","image":"DiskQuota_image__zTNTx"};